import { createContext } from 'react'

export type WorkspaceWalletBuckets = {
  trialCredits: number
  earnedCredits: number
  availableCredits: number
  reservedCredits: number
  lifetimeSpentCredits: number
}

export const EMPTY_WORKSPACE_WALLET: WorkspaceWalletBuckets = {
  trialCredits: 0,
  earnedCredits: 0,
  availableCredits: 0,
  reservedCredits: 0,
  lifetimeSpentCredits: 0,
}

export type CreditsScope = 'personal' | 'workspace'

export interface CreditsContextValue {
  uid: string | null
  activeWorkspaceId: string | null
  isPersonalWorkspace: boolean
  personalCredits: number
  personalCreditsLoading: boolean
  workspaceWallet: WorkspaceWalletBuckets
  workspaceWalletLoading: boolean
  /** Balance a credit-consuming action in the current workspace should draw from first.
   * For personal workspaces, this is the personal wallet. For team workspaces, this is the workspace wallet. */
  contextualBalance: number
  /** Whether the current workspace draws credits from personal or workspace source. */
  contextualScope: CreditsScope
  /** Total spendable across both wallets (personal + workspace.available). Used where the app pools both. */
  spendableTotal: number
}

export const CreditsContext = createContext<CreditsContextValue | undefined>(undefined)
